// Auto-generated version configuration
// This can be overridden during build via environment variables

export const VERSION_INFO = {
  version: process.env.REACT_APP_VERSION || 'unknown',
  buildNumber: process.env.REACT_APP_BUILD_NUMBER || 'local',
  buildDate: process.env.REACT_APP_BUILD_DATE || new Date().toISOString(),
  commitHash: process.env.REACT_APP_COMMIT_HASH || 'unknown',
  environment: process.env.NODE_ENV || 'development'
};

export const getVersionString = (): string => {
  const { version, buildNumber, environment } = VERSION_INFO;
  
  // In production, show clean version
  if (environment === 'production') {
    return `${version}.${buildNumber}`;
  }
  
  // In development, show more detailed info
  return `${version} (build: ${buildNumber})`;
};

export const getFullVersionInfo = () => VERSION_INFO;
